import http from '@/base/api/public'

let apiUrl = require('@/../config/sysConfig')

// 賞与明細 检索
export const p_0003Query = (params) => {
  return http.requestQuickGet(apiUrl.apiUrl_PaymentDetail + '?type=' + params.type + '&paidDate=' + params.paidDate + '&userCd=' + params.userCd)
}
// 賞与明細 確認情報保存
export const p_0003Save = (params, userCd) => {
  return http.requestPost(apiUrl.apiUrl_PaymentStatus + '?userCd=' + userCd, params);
}
//PDFダウンロード
export const p_0003GetFile = (photoPath) => {
  return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0')
}



// WEBPACK FOOTER //
// ./src/module/api/p_0003.js